import React from 'react'

import ContinueButton from './ContinueButton'
import { getScrollBarWidthFormatted } from '../../../../../../src/helpers/scrollbar'

import styles from './Buttons.module.scss'

const scrollBarWidth = getScrollBarWidthFormatted('half', 'rem')

export interface NavigationButtonsProps {
  handleBack: () => void
}

const NavigationButtons = ({ handleBack }: NavigationButtonsProps) => {
  return (
    <div className={styles.navButtons} style={{ marginLeft: scrollBarWidth }}>
      <ContinueButton />
    </div>
  )
}

export default NavigationButtons
